// HealthResponse schema — API response shape for GET /health.
//
// Session 39: extracted from packages/web/src/api/ingest.ts (TS-only interface)
// into a shared Zod schema so both frontend (safeParse) and backend (.parse())
// enforce the contract at runtime.
//
// The health endpoint returns provider/router status. The router field is a
// discriminated shape: either a routing table (success) or an error string.
import { z } from 'zod';
export const HealthResponseSchema = z.object({
    ok: z.boolean(),
    legacyProvider: z.string().optional(),
    legacyModel: z.string().optional(),
    router: z.union([
        z.object({
            enabledStages: z.array(z.string()).optional(),
            routingTable: z.record(z.string(), z.string()).optional(),
        }),
        z.object({ error: z.string() }),
    ]).optional(),
    keysConfigured: z.object({
        glm: z.boolean().optional(),
        deepseek: z.boolean().optional(),
        anthropic: z.boolean().optional(),
    }).optional(),
}).passthrough();
//# sourceMappingURL=health-response.js.map